import type { CSSProperties } from "react";

export type WorkforceFilter = "all" | "working" | "awaiting" | "available";

export interface WorkforceFilterCounts {
  all: number;
  working: number;
  awaiting: number;
  available: number;
}

export interface WorkforceFilterChipsProps {
  active: WorkforceFilter;
  counts: WorkforceFilterCounts;
  onChange: (filter: WorkforceFilter) => void;
}

const CHIPS: { key: WorkforceFilter; label: string }[] = [
  { key: "all", label: "All" },
  { key: "working", label: "At work" },
  { key: "awaiting", label: "Awaiting you" },
  { key: "available", label: "Available" },
];

export function WorkforceFilterChips({ active, counts, onChange }: WorkforceFilterChipsProps) {
  return (
    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", margin: "14px 0" }} role="tablist" aria-label="Filter">
      {CHIPS.map((chip) => {
        const isActive = chip.key === active;
        const count = counts[chip.key];
        const style: CSSProperties = {
          display: "inline-flex",
          alignItems: "center",
          gap: 4,
          padding: "4px 10px",
          borderRadius: 999,
          border: isActive
            ? "0.5px solid var(--color-border-secondary)"
            : "0.5px solid var(--color-border-tertiary)",
          background: isActive ? "var(--color-background-secondary)" : "transparent",
          color: "var(--color-text-primary)",
          fontSize: 12,
          fontWeight: isActive ? 500 : 400,
          fontFamily: "var(--font-sans)",
          cursor: "pointer",
        };
        return (
          <button
            key={chip.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            style={style}
            onClick={() => onChange(chip.key)}
          >
            {chip.label} {count}
          </button>
        );
      })}
    </div>
  );
}
